module.exports = __webpack_public_path__ + "img/logo.c57b7c81.svg";